module.exports = __webpack_public_path__ + "static/media/river-financial.6fbc2202.svg";